import { axiosObject } from "../config";
import { webStore, setUser } from "store";

export default function updateUser(data: any) {
  return new Promise((resolve, reject) => {
    let uri = "access/user";

    axiosObject
      .post(uri, data)
      .then(async (response) => {
        webStore.dispatch(setUser(response.data));
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
